import React from 'react';
import { ReportTemplateProps } from '../types';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import dayjs from 'dayjs';
import TableFooter from '@material-ui/core/TableFooter';

import { SPANISH_WEEK } from '../../helpers';
import { Table } from '@material-ui/core';

const VentasFamilia = ({
  reportTitle,
  formattedStartDate,
  formattedEndDate,
  reportData,
}: ReportTemplateProps) => (
  <Paper style={{ padding: '1em 1em 3em 1em' }}>
    {/* Shop: {shop}, Inicio: {startDate}, Fin: {endDate} */}
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom={true}>
          {`${reportData.nombre}: ${reportTitle}`}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom={true} align="right">
          <span style={{ fontWeight: 'bold' }}>Intervalo fechas:</span>{' '}
          {formattedStartDate} / {formattedEndDate}
        </Typography>
      </Grid>
    </Grid>
    <Grid container justifyContent="center">
      <TableContainer
        component={({ children }) => <Grid item>{children}</Grid>}
      >
        <Table id="report-table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell colSpan={2}>VENDIDO</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>DPTO</TableCell>
              <TableCell>FAMILIA</TableCell>
              <TableCell>Nº VENTAS</TableCell>
              <TableCell>en unidades</TableCell>
              <TableCell>a peso (Kg)</TableCell>
              <TableCell>IMPORTE (€)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData.detalle.map((row: any, idx: number) => (
              <>
                <TableRow key={idx}>
                  <TableCell colSpan={2}>{row.dpto}</TableCell>
                  <TableCell align="right">{row.ventas}</TableCell>
                  <TableCell align="right">{row.cantidadUd}</TableCell>
                  <TableCell align="right">{row.cantidadKg}</TableCell>
                  <TableCell align="right">{row.importe}</TableCell>
                  <TableCell align="right">{row.ticketMedio}</TableCell>
                </TableRow>
                {row.familias.map((familia: any, idx1: number) => (
                  <TableRow key={idx + ' ' + idx1}>
                    <TableCell></TableCell>
                    <TableCell>{familia.familia}</TableCell>
                    <TableCell align="right">{familia.ventas}</TableCell>
                    <TableCell align="right">{familia.cantidadUd}</TableCell>
                    <TableCell align="right">{familia.cantidadKg}</TableCell>
                    <TableCell align="right">{familia.importe}</TableCell>
                  </TableRow>
                ))}
              </>
            ))}
          </TableBody>
          <TableRow>
            <TableCell colSpan={2}></TableCell>
            <TableCell align="right">{reportData.total.ventas}</TableCell>
            <TableCell align="right">{reportData.total.cantidadUd}</TableCell>
            <TableCell align="right">{reportData.total.cantidadKg}</TableCell>
            <TableCell align="right">{reportData.total.importe}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </Table>
      </TableContainer>
    </Grid>
  </Paper>
);

export default React.memo(VentasFamilia);
